import { action as actionCreator } from "typesafe-actions";
export var ErrorHandlerActionType;
(function (ErrorHandlerActionType) {
    ErrorHandlerActionType["ShowError"] = "@@UNIK:domains:application:components:main-layout:components:error-handler-store:ShowError";
    ErrorHandlerActionType["HideError"] = "@@UNIK:domains:application:components:main-layout:components:error-handler-store:HideError";
})(ErrorHandlerActionType || (ErrorHandlerActionType = {}));
export const errorHandlerActions = {
    showError: (message) => actionCreator(ErrorHandlerActionType.ShowError, { message }),
    hideError: () => actionCreator(ErrorHandlerActionType.HideError)
};
const initialState = {};
export const errorHandlerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ErrorHandlerActionType.ShowError:
            return { message: action.payload.message };
        case ErrorHandlerActionType.HideError:
            return { message: undefined };
        default:
            return state;
    }
};
